<template>
    <header class="header--main" v-if="headerVisibility">
        <div class="container">
            <a href="javascript:;">Skip</a>
        </div>
    </header>
    <section class="promo-section" :style="{minHeight: !headerVisibility? '100dvh': '' }">
        <div class="container">
            <div class="heading-box">
                <h1><strong>Special Godfather Offer:
                </strong></h1>
                <p>We pay your first dinner date worth chf 200.</p>
            </div>

            <div class="promo-grid">
                <div class="grid-item grid-item-payment-method">
                    <h2>Paymant method:</h2>

                    <div class="drop-trigger" @click="paymentDropdown = !paymentDropdown">
                        <p>{{ radioValue }}</p>
                        <span>
                            Change
                            <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1.33056 0.233087C1.02066 -0.0837732 0.523898 -0.0765989 0.221969 0.249827C-0.0799608 0.575058 -0.0731249 1.09638 0.237919 1.41324L6.48045 7.7648L7.02621 7.17532L6.47931 7.7672C6.7915 8.08406 7.2894 8.07688 7.59133 7.74926C7.60044 7.73969 7.60842 7.73013 7.61639 7.72056L13.7621 1.41205C14.0731 1.09519 14.08 0.575058 13.778 0.248632C13.4761 -0.0765989 12.9805 -0.0837732 12.6694 0.233087L7.02393 6.02745L1.33056 0.233087Z" fill="white"/>
                            </svg>
                        </span>
                    </div>
                    <div class="box box-drop" :class="paymentDropdown? 'active':''">
                        <div class="dropdown">
                            <p>Select payment type</p>
                            <ul>
                                <li>
                                    <div class="radio-box">
                                        <input id="radio1" checked type="radio" name="radio" value="Credit card" @change="getValue">
                                        <label for="radio1">
                                            <div class="radio-icon"></div>
                                            <svg width="29" height="18" viewBox="0 0 29 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g clip-path="url(#clip0_1_246)">
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M19.9353 10.3577C20.6786 10.3577 21.339 10.7167 21.751 11.269C22.1629 10.7144 22.8233 10.3577 23.5666 10.3577C24.8162 10.3577 25.8287 11.3703 25.8287 12.6198C25.8287 13.8694 24.8162 14.8819 23.5666 14.8819C22.8233 14.8819 22.1629 14.5229 21.751 13.9706C21.339 14.5252 20.6786 14.8819 19.9353 14.8819C18.6858 14.8819 17.6732 13.8694 17.6732 12.6198C17.6732 11.3703 18.6858 10.3577 19.9353 10.3577ZM1.55561 3.05176e-05H26.7216C27.1496 3.05176e-05 27.5385 0.174922 27.8192 0.455668C28.1 0.736415 28.2749 1.12762 28.2749 1.55334V16.4421C28.2749 16.8701 28.1 17.259 27.8192 17.5398C27.5385 17.8205 27.1496 17.9977 26.7216 17.9977H1.55561C1.12759 17.9977 0.738686 17.8228 0.457939 17.5421C0.174891 17.2613 0 16.8724 0 16.4444V1.55564C0 1.12762 0.174891 0.738716 0.455638 0.455668C0.738686 0.174922 1.12759 3.05176e-05 1.55561 3.05176e-05ZM3.8338 11.888C3.58527 11.888 3.38277 11.6855 3.38277 11.437C3.38277 11.1885 3.58527 10.986 3.8338 10.986H11.4163C11.6648 10.986 11.8673 11.1885 11.8673 11.437C11.8673 11.6855 11.6648 11.888 11.4163 11.888H3.8338ZM3.8338 14.2537C3.58527 14.2537 3.38277 14.0512 3.38277 13.8026C3.38277 13.5541 3.58527 13.3516 3.8338 13.3516H8.94937C9.1979 13.3516 9.40041 13.5541 9.40041 13.8026C9.40041 14.0512 9.1979 14.2537 8.94937 14.2537H3.8338ZM0.89977 3.35058H27.3751V1.55564C27.3751 1.37615 27.3015 1.21276 27.1818 1.0931C27.0621 0.973439 26.8987 0.8998 26.7193 0.8998H1.55561C1.37612 0.8998 1.21273 0.973439 1.09307 1.0931C0.973408 1.21276 0.89977 1.37615 0.89977 1.55564V3.35058ZM27.3774 7.82182H0.89977V16.4444C0.89977 16.6239 0.973408 16.7873 1.09307 16.907C1.21273 17.0266 1.37612 17.1003 1.55561 17.1003H26.7216C26.9011 17.1003 27.0644 17.0266 27.1841 16.907C27.3038 16.7873 27.3774 16.6239 27.3774 16.4444V7.82182Z" fill="white"/>
                                                </g>
                                                <defs>
                                                <clipPath id="clip0_1_246">
                                                <rect width="28.2772" height="18" fill="white"/>
                                                </clipPath>
                                                </defs>
                                            </svg>
                                            <p class="radio-text">Credit card </p>
                                        </label>
                                    </div>
                                </li>
                                <li>
                                    <div class="radio-box">
                                        <input id="radio2" type="radio" name="radio" value="Paypal" @change="getValue">
                                        <label for="radio2">
                                            <div class="radio-icon"></div>
                                            <svg width="82" height="20" viewBox="0 0 82 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M7.15523 4.70792H12.7613C15.7713 4.70792 16.9059 6.23913 16.7257 8.49566C16.4387 12.2162 14.2029 14.2713 11.2397 14.2713H9.74471C9.3376 14.2713 9.06397 14.5399 8.95719 15.2787L8.32316 19.5433C8.28312 19.8186 8.13629 19.9798 7.92273 19.9999H4.39889C4.06519 19.9999 3.95173 19.7447 4.0385 19.194L6.18083 5.51382C6.26759 4.96983 6.56124 4.70792 7.15523 4.70792Z" fill="#009EE3"/>
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M31.488 4.45255C33.3767 4.45255 35.1253 5.48679 34.885 8.05896C34.598 11.1147 32.9696 12.8071 30.4001 12.8138H28.1577C27.8373 12.8138 27.6771 13.0757 27.5971 13.6197L27.1633 16.3933C27.0965 16.8097 26.883 17.0179 26.5693 17.0179H24.4803C24.1466 17.0179 24.0332 16.803 24.1066 16.3262L25.8285 5.19801C25.9152 4.64731 26.1154 4.44583 26.4892 4.44583H31.488V4.45255ZM28.0843 10.4095H29.7861C30.8473 10.3692 31.5547 9.63048 31.6281 8.29402C31.6682 7.46797 31.1142 6.87697 30.2333 6.88369L28.6315 6.89041L28.0843 10.4095ZM40.5579 16.1717C40.7514 15.9971 40.9449 15.9098 40.9182 16.1247L40.8515 16.6418C40.8181 16.9105 40.9249 17.0515 41.1719 17.0515H43.0272C43.3409 17.0515 43.4944 16.9239 43.5678 16.4404L44.709 9.22081C44.7691 8.85815 44.6757 8.68354 44.402 8.68354H42.3598C42.1729 8.68354 42.0862 8.78428 42.0395 9.06634L41.9661 9.50959C41.926 9.73793 41.8192 9.78494 41.7258 9.54989C41.3787 8.72384 40.4978 8.35446 39.2631 8.38804C36.4 8.44848 34.4779 10.6311 34.271 13.4317C34.1108 15.6009 35.6525 17.3 37.6881 17.3C39.163 17.2933 39.8237 16.8567 40.5579 16.1717ZM39.0028 15.0636C37.7748 15.0636 36.9139 14.0764 37.0941 12.8608C37.2743 11.652 38.4222 10.658 39.6569 10.658C40.8915 10.658 41.7458 11.6452 41.5656 12.8608C41.3854 14.0697 40.2375 15.0636 39.0028 15.0636ZM48.333 8.65668H46.4509C46.0639 8.65668 45.9037 8.94546 46.0305 9.30812L48.3664 16.1852L46.0772 19.4558C45.8837 19.7311 46.0372 19.9796 46.3041 19.9796H48.4198C48.4465 19.9796 48.4665 19.9863 48.4932 19.9863C48.7201 19.9863 48.927 19.8655 49.0471 19.6707L56.2283 9.30812C56.4485 8.99247 56.3484 8.65668 55.9813 8.65668H53.9791C53.6388 8.65668 53.4986 8.79099 53.3051 9.07978L50.3085 13.4451L48.9737 9.06634C48.8936 8.79771 48.7001 8.65668 48.333 8.65668Z" fill="#113984"/>
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M63.6962 4.45255C65.5849 4.45255 67.3335 5.48679 67.0933 8.05897C66.8063 11.1147 65.1778 12.8071 62.6084 12.8138H60.3659C60.0456 12.8138 59.8854 13.0757 59.8053 13.6197L59.3715 16.3934C59.3048 16.8097 59.0912 17.0179 58.7775 17.0179H56.6886C56.3549 17.0179 56.2414 16.803 56.3148 16.3262L58.0434 5.19801C58.1302 4.65402 58.3304 4.44583 58.7041 4.44583L63.6962 4.45255ZM60.2992 10.4095H62.001C63.0622 10.3692 63.7696 9.63048 63.8431 8.29402C63.8831 7.46797 63.3292 6.87697 62.4482 6.88369L60.8464 6.89041L60.2992 10.4095ZM72.7661 16.1717C72.9597 15.9971 73.1532 15.9098 73.1265 16.1247L73.0598 16.6418C73.0264 16.9105 73.1332 17.0515 73.3801 17.0515H75.2355C75.5491 17.0515 75.7026 16.9239 75.7761 16.4404L76.9173 9.22081C76.9774 8.85815 76.8839 8.68354 76.6103 8.68354H74.5747C74.3879 8.68354 74.3011 8.78428 74.2544 9.06634L74.181 9.50959C74.1409 9.73793 74.0342 9.78494 73.9407 9.54989C73.5937 8.72384 72.7127 8.35446 71.4847 8.38804C68.6216 8.44848 66.6995 10.6311 66.4926 13.4317C66.3324 15.6009 67.8741 17.3 69.9097 17.3C71.3846 17.3 72.0453 16.8635 72.7861 16.1784L72.7661 16.1717ZM71.2178 15.0636C69.9897 15.0636 69.1288 14.0764 69.309 12.8608C69.4892 11.652 70.6371 10.658 71.8718 10.658C73.0998 10.658 73.9607 11.6452 73.7805 12.8608C73.6004 14.0697 72.4458 15.0636 71.2178 15.0636ZM79.7671 17.0582H77.6247C77.6181 17.0582 77.6181 17.0582 77.6114 17.0582C77.4712 17.0582 77.3578 16.9441 77.3578 16.803C77.3578 16.7896 77.3578 16.7762 77.3578 16.7694L79.2398 4.78162C79.2799 4.61373 79.4267 4.49284 79.5935 4.49284H81.7359C81.7426 4.49284 81.7426 4.49284 81.7492 4.49284C81.8894 4.49284 82.0028 4.60701 82.0028 4.74805C82.0028 4.76148 82.0028 4.77491 82.0028 4.78162L80.1208 16.7694C80.0874 16.9373 79.9406 17.0582 79.7671 17.0582Z" fill="#009EE3"/>
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M3.65149 3.05176e-05H9.26427C10.846 3.05176e-05 12.7214 0.0537574 13.9694 1.16187C14.8036 1.90733 15.2441 3.08933 15.144 4.36534C14.797 8.67692 12.2409 11.0879 8.80377 11.0879H6.03409C5.56024 11.0879 5.25324 11.4036 5.11976 12.2498L4.34558 17.1993C4.29219 17.5217 4.15871 17.7098 3.91177 17.7299H0.454672C0.0742574 17.7299 -0.0658953 17.4411 0.0342138 16.7964L2.52359 0.940251C2.6237 0.302244 2.97075 3.05176e-05 3.65149 3.05176e-05Z" fill="#113984"/>
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M5.19971 11.7529L6.18078 5.51382C6.26754 4.96984 6.56119 4.7012 7.15517 4.7012H12.7613C13.689 4.7012 14.4364 4.84895 15.0237 5.11759C14.4631 8.95234 11.9938 11.088 8.76359 11.088H6.00725C5.63351 11.088 5.36656 11.276 5.19971 11.7529Z" fill="#172C70"/>
                                            </svg>
                                        </label>
                                    </div>
                                </li>
                                <li>
                                    <div class="radio-box">
                                        <input id="radio3" type="radio" name="radio" value="CashtoCode" @change="getValue">
                                        <label for="radio3">
                                            <div class="radio-icon"></div>
                                            <svg fill="none" width="65" viewBox="0 0 65 18">
                                                <path fill="#479FDD" d="M0 0h65v18H0z"/>
                                                <path fill="#fff" d="M8.23 13.11c-.52 0-1-.09-1.45-.27a3.66 3.66 0 0 1-1.95-1.92 3.71 3.71 0 0 1-.27-1.42 3.51 3.51 0 0 1 2.23-3.33 3.7 3.7 0 0 1 2.51-.13 3.6 3.6 0 0 1 1.75 1.06l-.7.72a2.84 2.84 0 0 0-3.16-.76A2.54 2.54 0 0 0 5.63 9.5a2.58 2.58 0 0 0 2.63 2.64 2.62 2.62 0 0 0 2.08-.94l.69.7a4.01 4.01 0 0 1-1.76 1.07c-.34.1-.69.14-1.04.14Zm5.32-.02c-.37 0-.7-.06-.97-.19-.28-.13-.5-.32-.66-.55a1.4 1.4 0 0 1-.24-.81c0-.48.18-.86.55-1.13.36-.28.87-.42 1.5-.42.5 0 .97.1 1.4.29v-.54c0-.37-.1-.64-.32-.82-.2-.18-.52-.27-.92-.27-.24 0-.48.04-.73.11a5.1 5.1 0 0 0-.85.32l-.37-.75c.38-.18.74-.31 1.08-.39a4 4 0 0 1 1-.13c.67 0 1.18.16 1.54.47.36.31.55.76.55 1.34V13h-.98v-.44a2.38 2.38 0 0 1-1.58.53Zm-.91-1.57c0 .25.1.45.3.6.22.15.5.23.84.23.26 0 .5-.04.73-.12.22-.08.43-.2.62-.37V11a2.8 2.8 0 0 0-1.31-.32c-.37 0-.66.08-.87.23a.7.7 0 0 0-.31.61ZM19 13.1c-.44 0-.85-.06-1.24-.19a3.06 3.06 0 0 1-.99-.56l.55-.66c.26.2.53.37.8.48.28.1.56.16.85.16.36 0 .65-.07.88-.21.23-.14.34-.32.34-.55a.53.53 0 0 0-.2-.44c-.13-.1-.34-.18-.62-.22l-.92-.13c-.5-.07-.89-.23-1.14-.47a1.26 1.26 0 0 1-.38-.96c0-.3.08-.57.25-.8.17-.23.4-.41.7-.54.3-.13.65-.2 1.05-.2a3.52 3.52 0 0 1 2.04.66l-.51.66a3.36 3.36 0 0 0-.82-.41 2.48 2.48 0 0 0-.79-.13c-.3 0-.55.07-.74.2a.58.58 0 0 0-.28.5c0 .19.06.33.19.44.13.1.35.17.65.21l.92.13c.5.07.89.23 1.15.47.26.23.39.55.39.95 0 .3-.1.58-.28.83a1.9 1.9 0 0 1-.76.57 2.7 2.7 0 0 1-1.09.21Zm2.9-.1V6l1-.22v2.65c.4-.41.9-.62 1.53-.62.4 0 .73.08 1.03.25.3.17.53.4.7.7.17.3.26.65.26 1.04V13h-1V9.97c0-.4-.11-.71-.34-.94a1.24 1.24 0 0 0-.93-.35 1.43 1.43 0 0 0-1.25.66V13h-1Zm7.5.1c-.38 0-.67-.1-.87-.28-.2-.19-.3-.45-.3-.78V8.48h-1.08v-.4h1.08V6.84l.44-.14v1.38h1.52v.4h-1.52v3.41c0 .28.06.48.18.61.13.12.34.18.62.18.16 0 .29-.01.4-.03l.32-.11v.43a2.76 2.76 0 0 1-.8.13Zm3.67 0c-.46 0-.87-.11-1.24-.34a2.5 2.5 0 0 1-1.21-2.22 2.5 2.5 0 0 1 1.21-2.22c.37-.23.78-.34 1.24-.34a2.43 2.43 0 0 1 2.12 1.26c.22.39.33.82.33 1.3a2.62 2.62 0 0 1-1.21 2.22c-.37.23-.78.34-1.24.34Zm0-.42c.37 0 .7-.1 1-.28.31-.2.55-.45.73-.77.18-.33.27-.69.27-1.09a2.16 2.16 0 0 0-1-1.85c-.3-.2-.63-.29-1-.29-.38 0-.72.1-1.02.29-.3.19-.54.44-.72.77-.18.32-.26.68-.26 1.08s.08.76.26 1.09a1.92 1.92 0 0 0 1.74 1.05Zm6.98.43c-.52 0-1-.09-1.45-.27a3.66 3.66 0 0 1-1.95-1.92 3.71 3.71 0 0 1-.27-1.42 3.51 3.51 0 0 1 2.23-3.33 3.7 3.7 0 0 1 2.5-.13 3.6 3.6 0 0 1 1.76 1.06l-.7.72a2.84 2.84 0 0 0-3.16-.76 2.54 2.54 0 0 0-1.56 2.44 2.58 2.58 0 0 0 2.63 2.64 2.62 2.62 0 0 0 2.08-.94l.69.7a4.02 4.02 0 0 1-1.76 1.07c-.34.1-.69.14-1.04.14Zm5.98-.01a2.6 2.6 0 0 1-2.65-2.64 2.61 2.61 0 0 1 2.65-2.65 2.6 2.6 0 0 1 2.65 2.65 2.61 2.61 0 0 1-2.65 2.64Zm0-.88a1.6 1.6 0 0 0 1.45-.87c.14-.27.22-.57.22-.9 0-.33-.08-.62-.23-.88a1.73 1.73 0 0 0-.6-.64 1.5 1.5 0 0 0-.84-.24c-.32 0-.6.08-.85.24a1.76 1.76 0 0 0-.82 1.52c0 .33.07.63.22.9a1.61 1.61 0 0 0 1.45.87Zm5.93.86a2.57 2.57 0 0 1-2.57-2.63c0-.5.12-.94.34-1.33.24-.4.55-.7.94-.94.4-.23.83-.35 1.31-.35a2.54 2.54 0 0 1 1.53.51V6l1-.19V13h-.99v-.49c-.43.38-.95.57-1.56.57Zm.13-.87c.3 0 .56-.05.8-.16.25-.1.46-.26.62-.46V9.3a1.75 1.75 0 0 0-.62-.44 1.85 1.85 0 0 0-1.67.06 1.72 1.72 0 0 0-.85 1.52 1.77 1.77 0 0 0 .85 1.54c.26.15.55.23.87.23Zm6.05.88a2.68 2.68 0 0 1-2.32-1.3c-.24-.4-.35-.85-.35-1.34a2.6 2.6 0 0 1 2.55-2.63c.47 0 .89.12 1.26.36a2.77 2.77 0 0 1 1.2 2.32v.28h-4.01c.05.28.15.53.3.75a1.73 1.73 0 0 0 1.4.71c.25 0 .49-.04.72-.11.23-.08.42-.2.58-.34l.64.63c-.3.23-.61.4-.93.51-.32.1-.66.16-1.04.16Zm-1.66-3.06h3c-.03-.27-.13-.5-.27-.7-.14-.2-.32-.37-.53-.48a1.47 1.47 0 0 0-1.92.47c-.14.2-.24.44-.28.71Z"/>
                                            </svg>
                                        </label>
                                    </div>
                                </li>
                                <li>
                                    <div class="radio-box">
                                        <input id="radio4" type="radio" name="radio" value="Online bank Transfer" @change="getValue">
                                        <label for="radio4">
                                            <div class="radio-icon"></div>
                                            <svg width="31" height="26" viewBox="0 0 31 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g clip-path="url(#clip0_1_226)">
                                                    <path d="M15.8565 1.38553C13.3748 1.72492 11.0009 2.91277 9.2331 4.68711L9.23072 4.68949C8.85787 5.06053 8.51148 5.45726 8.19411 5.87675H11.7797C12.8175 4.38702 14.1751 2.89074 15.8565 1.38553ZM1.24501 12.3453H18.1739C18.858 12.3453 19.4189 12.9062 19.4189 13.5904V24.755C19.4189 25.4367 18.8562 26 18.1739 26H1.24501C0.562072 26 0 25.4379 0 24.755V13.5904C0 12.9068 0.561477 12.3453 1.24501 12.3453ZM4.10837 23.0771C3.89283 23.0771 3.71837 22.9021 3.71837 22.6871C3.71837 22.4722 3.89283 22.2971 4.10837 22.2971H8.11253C8.21592 22.2973 8.31502 22.3384 8.38813 22.4115C8.46123 22.4846 8.50237 22.5837 8.50253 22.6871C8.50237 22.7905 8.46123 22.8896 8.38813 22.9627C8.31502 23.0358 8.21592 23.0769 8.11253 23.0771H4.10837ZM4.10837 21.2254C3.89283 21.2254 3.71837 21.0509 3.71837 20.836C3.71837 20.621 3.89283 20.446 4.10837 20.446H10.0435C10.1468 20.4461 10.246 20.4873 10.3191 20.5604C10.3922 20.6335 10.4333 20.7326 10.4335 20.836C10.4335 21.0509 10.2584 21.2254 10.0435 21.2254H4.10837ZM12.861 19.9905C13.4427 19.9905 13.9589 20.2709 14.2816 20.7044C14.6049 20.2709 15.1212 19.9905 15.7029 19.9905C16.6812 19.9905 17.4737 20.7836 17.4737 21.7612C17.4737 22.7395 16.6812 23.5326 15.7029 23.5326C15.1212 23.5326 14.6049 23.2516 14.2816 22.8187C13.9589 23.2516 13.4427 23.5326 12.861 23.5326C11.8827 23.5326 11.0902 22.7395 11.0902 21.7612C11.0902 20.7836 11.8827 19.9905 12.861 19.9905ZM0.760345 14.9955H18.6585V13.5904C18.6585 13.3254 18.4388 13.1057 18.1739 13.1057H1.24501C0.977076 13.1057 0.760345 13.3224 0.760345 13.5904V14.9955ZM18.6585 18.496H0.760345V24.755C0.760345 25.0205 0.979458 25.2397 1.24501 25.2397H18.1739C18.4388 25.2397 18.6585 25.0199 18.6585 24.755V18.496ZM27.5969 18.7901C27.6219 18.7901 27.6469 18.7919 27.6713 18.7943C28.5883 17.1831 29.1003 15.4737 29.1944 13.6082H25.7928C25.7184 15.3593 25.1998 17.0866 24.2435 18.7901H27.5969ZM26.8348 20.0649H23.4439C23.039 20.649 22.5829 21.2295 22.0744 21.8083V18.7901H22.7663C23.8488 17.0741 24.4382 15.3468 24.5222 13.6082H22.0744V12.3334H24.4936C24.3364 10.6317 23.6999 8.90503 22.5764 7.15153H18.1518V9.91605H16.877V7.15153H12.4525C11.8571 8.08038 11.3992 9.00149 11.0759 9.91605H9.73802C10.0256 8.99732 10.4352 8.07562 10.9681 7.15153H7.35576C6.85978 8.02382 6.46919 8.94611 6.21018 9.91605H4.8961C5.25394 8.41858 5.90116 6.98005 6.75796 5.70348C7.21903 5.01559 7.74652 4.37463 8.33284 3.78982C10.7609 1.35219 14.0709 0 17.5147 0C18.4073 0 19.2754 0.084549 20.1179 0.253051C23.4177 0.912772 26.3983 2.91277 28.2715 5.70348C29.7344 7.8827 30.4853 10.337 30.4853 12.9705C30.4853 15.6082 29.7333 18.0595 28.2715 20.2382C26.8568 22.3447 24.8991 23.9262 22.5722 24.9271C22.4073 24.9973 22.2417 25.064 22.0744 25.1271V23.7553C23.9702 22.9366 25.5892 21.7094 26.8348 20.0649ZM25.7684 12.3334H29.1944C29.1003 10.4698 28.5912 8.7663 27.6737 7.15153H24.0607C25.0628 8.88896 25.6297 10.6163 25.7684 12.3334ZM13.3522 5.87675H16.877V2.17624C15.4659 3.42245 14.2918 4.65555 13.3522 5.87675ZM18.1518 5.87675H21.6773C20.7371 4.65555 19.5636 3.42245 18.1518 2.17624V5.87675ZM23.2498 5.87675H26.8354C25.1426 3.64275 22.6186 2.05299 19.869 1.50283C19.6392 1.45698 19.4076 1.41828 19.173 1.38613C20.8544 2.89074 22.2114 4.38761 23.2498 5.87675Z" fill="white"/>
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_1_226">
                                                    <rect width="30.4853" height="26" fill="white"/>
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                            <p class="radio-text">Online bank transfer </p>
                                        </label>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="grid-item grid-item-premium">
                    <div class="box">
                        <svg width="76" height="66" viewBox="0 0 76 66" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_1_285)">
                                <path d="M13.0376 51.366H27.8813C27.8714 50.0552 28.1287 48.7559 28.6377 47.546C29.1468 46.3361 29.8972 45.2405 30.8439 44.3248C32.2551 42.933 34.0501 41.9855 36.0032 41.6015C37.9563 41.2175 39.9803 41.4141 41.821 42.1665C43.6617 42.919 45.2368 44.1937 46.3484 45.8305C47.4601 47.4673 48.0586 49.3932 48.0688 51.366H62.7147L70.4396 30.1198C70.8598 30.2495 71.2983 30.3116 71.7384 30.3036C72.5827 30.3036 73.4081 30.0555 74.11 29.5906C74.8119 29.1257 75.3589 28.4649 75.6817 27.6919C76.0046 26.9189 76.0887 26.0684 75.9235 25.248C75.7584 24.4276 75.3513 23.6742 74.7539 23.0831C74.1564 22.492 73.3954 22.0898 72.5672 21.9273C71.739 21.7648 70.8807 21.8494 70.101 22.1704C69.3213 22.4914 68.6552 23.0343 68.1871 23.7305C67.7189 24.4267 67.4696 25.2448 67.4708 26.0813C67.4698 26.9622 67.7514 27.8206 68.2749 28.5326L63.8898 32.1482C57.7049 37.1671 53.8765 34.8384 55.0516 27.068L55.7319 22.6557C55.9758 22.7065 56.2251 22.7271 56.4741 22.717C57.4788 22.7153 58.4505 22.3614 59.2172 21.718C59.9838 21.0746 60.496 20.1832 60.6629 19.2016C60.8299 18.2199 60.641 17.2114 60.1295 16.3546C59.6181 15.4977 58.8171 14.8478 57.8685 14.5199C56.9198 14.1921 55.8847 14.2073 54.9463 14.5631C54.008 14.9188 53.2269 15.5921 52.7414 16.4636C52.256 17.3352 52.0974 18.3488 52.2938 19.3251C52.4902 20.3014 53.029 21.1773 53.8146 21.7978L52.7694 23.4524C47.574 31.1677 43.7456 28.2262 42.255 20.5783L39.5461 8.14429C40.3149 7.82853 40.9717 7.29355 41.4331 6.60726C41.8945 5.92097 42.1397 5.11431 42.1375 4.28969C42.1117 3.14624 41.6364 2.05796 40.8126 1.25669C39.9889 0.455425 38.882 0.00450678 37.7277 0C36.598 0.00162103 35.5151 0.446988 34.7162 1.23847C33.9174 2.02995 33.4679 3.10296 33.4663 4.22228C33.4584 5.14831 33.7643 6.05019 34.3351 6.7835C34.9059 7.51681 35.7085 8.03914 36.6144 8.26685L34.8208 15.3694C33.3983 21.8591 31.5428 34.8323 23.2303 23.7526L21.8758 21.9142C22.4238 21.5205 22.8709 21.0049 23.1813 20.4089C23.4917 19.8129 23.6568 19.1531 23.6632 18.4825C23.6632 17.6474 23.4133 16.831 22.9451 16.1367C22.4768 15.4423 21.8113 14.9011 21.0326 14.5816C20.2539 14.262 19.3971 14.1784 18.5705 14.3413C17.7439 14.5042 16.9846 14.9063 16.3886 15.4968C15.7926 16.0873 15.3868 16.8397 15.2223 17.6587C15.0579 18.4778 15.1423 19.3267 15.4648 20.0982C15.7874 20.8698 16.3336 21.5292 17.0343 21.9932C17.7351 22.4571 18.559 22.7047 19.4019 22.7047C19.7144 22.6941 20.0251 22.653 20.3296 22.5822L20.6388 25.4624C21.1955 29.3783 21.8758 34.6546 17.3608 34.4033C15.1405 34.2808 14.2684 33.5454 12.5428 32.3198L7.66292 28.888C8.22543 28.1598 8.52978 27.268 8.5288 26.351C8.53003 25.5144 8.28078 24.6963 7.8126 24.0001C7.34441 23.304 6.67834 22.761 5.89865 22.4401C5.11896 22.1191 4.2607 22.0345 3.43246 22.1969C2.60423 22.3594 1.84324 22.7616 1.24579 23.3527C0.648338 23.9439 0.241276 24.6973 0.0761082 25.5177C-0.0890591 26.3381 -0.00490882 27.1886 0.317911 27.9616C0.640732 28.7346 1.18771 29.3953 1.88965 29.8602C2.59158 30.3251 3.41692 30.5733 4.26123 30.5733C4.79122 30.5658 5.31532 30.4619 5.80745 30.2669L13.0376 51.366ZM37.7277 1.89972C38.1928 1.89972 38.6474 2.03645 39.0341 2.29261C39.4207 2.54876 39.7219 2.91281 39.8996 3.33868C40.0773 3.76455 40.1235 4.23309 40.0323 4.68498C39.9411 5.13686 39.7167 5.55179 39.3874 5.87721C39.0581 6.20264 38.6387 6.42394 38.1824 6.5131C37.7261 6.60226 37.2533 6.55527 36.824 6.37808C36.3946 6.20089 36.028 5.90146 35.7705 5.5177C35.513 5.13394 35.3762 4.68312 35.3774 4.22228C35.3791 3.60574 35.6274 3.015 36.068 2.57961C36.5086 2.14422 37.1054 1.89972 37.7277 1.89972ZM71.59 23.6301C72.0976 23.6362 72.592 23.7913 73.0106 24.0758C73.4292 24.3602 73.7533 24.7613 73.9419 25.2283C74.1305 25.6953 74.1751 26.2072 74.0701 26.6993C73.965 27.1914 73.7151 27.6416 73.3518 27.9929C72.9886 28.3443 72.5283 28.581 72.0293 28.6732C71.5303 28.7654 71.0149 28.7089 70.5482 28.5108C70.0816 28.3128 69.6847 27.9821 69.4078 27.5605C69.1308 27.139 68.9863 26.6456 68.9923 26.1426C68.9956 25.8084 69.0654 25.4781 69.1979 25.1707C69.3303 24.8633 69.5227 24.5849 69.7641 24.3514C70.0055 24.1179 70.2911 23.934 70.6044 23.8102C70.9178 23.6864 71.2527 23.6252 71.59 23.6301ZM4.17464 23.6301C4.52189 23.6132 4.86899 23.6664 5.19488 23.7864C5.52077 23.9064 5.81865 24.0908 6.07046 24.3283C6.32226 24.5658 6.52273 24.8516 6.65971 25.1682C6.79669 25.4848 6.86733 25.8257 6.86733 26.1702C6.86733 26.5147 6.79669 26.8556 6.65971 27.1722C6.52273 27.4888 6.32226 27.7746 6.07046 28.0121C5.81865 28.2496 5.52077 28.434 5.19488 28.554C4.86899 28.674 4.52189 28.7272 4.17464 28.7103C3.49932 28.6974 2.85664 28.42 2.38721 27.9388C1.91778 27.4576 1.65982 26.8118 1.66976 26.1426C1.66562 25.812 1.72818 25.484 1.85376 25.1777C1.97935 24.8714 2.16542 24.5931 2.40107 24.359C2.63671 24.125 2.91717 23.9399 3.22598 23.8148C3.5348 23.6896 3.86574 23.6268 4.19938 23.6301H4.17464ZM19.34 15.9331C20.0115 15.9364 20.6546 16.2021 21.1295 16.6726C21.6043 17.1431 21.8726 17.7803 21.8758 18.4457C21.8758 19.1202 21.6054 19.767 21.124 20.244C20.6427 20.7209 19.9898 20.9889 19.3091 20.9889C18.6283 20.9889 17.9755 20.7209 17.4941 20.244C17.0128 19.767 16.7423 19.1202 16.7423 18.4457C16.7691 17.7773 17.0533 17.1444 17.5364 16.6771C18.0195 16.2098 18.6649 15.9436 19.34 15.9331ZM56.3504 15.9331C56.6875 15.9331 57.0212 15.9989 57.3327 16.1267C57.6441 16.2545 57.927 16.4419 58.1654 16.678C58.4037 16.9142 58.5928 17.1945 58.7218 17.5031C58.8508 17.8116 58.9171 18.1423 58.9171 18.4763C58.9171 18.8103 58.8508 19.141 58.7218 19.4496C58.5928 19.7581 58.4037 20.0385 58.1654 20.2746C57.927 20.5108 57.6441 20.6981 57.3327 20.8259C57.0212 20.9537 56.6875 21.0195 56.3504 21.0195C55.6697 21.0195 55.0168 20.7516 54.5355 20.2746C54.0541 19.7977 53.7837 19.1508 53.7837 18.4763C53.7837 17.8018 54.0541 17.155 54.5355 16.678C55.0168 16.2011 55.6697 15.9331 56.3504 15.9331ZM13.0561 57.2613H29.842C30.1379 57.6765 30.4689 58.066 30.8315 58.4256C32.7167 60.2948 35.2711 61.3499 37.938 61.361C40.6206 61.3379 43.1899 60.2858 45.1063 58.4256C45.4689 58.066 45.7999 57.6765 46.0959 57.2613H62.7951V66H13.0376V57.2429L13.0561 57.2613Z" fill="#B98A56"/>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M37.9381 44.4473C39.3191 44.4473 40.6692 44.8531 41.8175 45.6133C42.9658 46.3736 43.8608 47.4541 44.3893 48.7183C44.9178 49.9826 45.0561 51.3737 44.7866 52.7158C44.5172 54.0578 43.8522 55.2906 42.8756 56.2582C41.8991 57.2258 40.6549 57.8848 39.3003 58.1517C37.9458 58.4187 36.5418 58.2817 35.2659 57.758C33.99 57.2343 32.8994 56.3476 32.1321 55.2098C31.3649 54.072 30.9553 52.7344 30.9553 51.366C30.9545 50.4572 31.1346 49.5572 31.4852 48.7174C31.8358 47.8776 32.3501 47.1146 32.9987 46.472C33.6473 45.8293 34.4174 45.3197 35.2649 44.9723C36.1125 44.6249 37.0209 44.4465 37.9381 44.4473Z" fill="#B98A56"/>
                            </g>
                            <defs>
                                <clipPath id="clip0_1_285">
                                <rect width="76" height="66" fill="white"/>
                                </clipPath>
                            </defs>
                        </svg>
                        <h2>Premium</h2>
                        <h3>30 dinner dates unlocks</h3>
                        <div class="divider"></div>

                        <h4>300 credits
                            <svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M0.291359 14.4794C-0.104716 14.8335 -0.0957487 15.4013 0.312284 15.7463C0.718822 16.0914 1.37048 16.0836 1.76655 15.7281L9.70601 8.59377L8.96916 7.97005L9.70899 8.59507C10.1051 8.23829 10.0961 7.66926 9.68657 7.3242C9.67462 7.31378 9.66266 7.30467 9.6507 7.29555L1.76506 0.271909C1.36898 -0.0835706 0.718822 -0.0913833 0.310789 0.253679C-0.0957487 0.598741 -0.104716 1.16516 0.291359 1.52064L7.53431 7.97266L0.291359 14.4794Z" fill="#B98A56"/>
                            </svg>
                            <span>CHF 300.00</span>
                        </h4>
                        <a href="javascript:;" class="button button--primary">Buy Your Package</a>
                        <!-- <p class="text">Secure Your Dinnerdate</p> -->

                        <div class="check-box">
                            <input id="check1" type="checkbox" checked name="">
                            <label for="check1">
                                <div class="check-icon">
                                    <svg fill="none" width="9" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="4" viewBox="0 0 24 24">
                                    <path d="M20 6 9 17l-5-5"/>
                                    </svg>
                                </div>
                                <p class="check-text">I accept the <a href="#">Terms & Conditions</a>  and the <a href="#">Consent Policy</a> of HALOSAURIDAE LTD.</p>
                            </label>
                        </div>
                    </div>
                    <a href="javascript:;"  @click="popupTrigger = true" class="popup-trigger">Rules to claim CHF200</a>
                </div>
                <div class="grid-item grid-item-gift">
                    <h3 class="mb0">OUR Gift</h3>
                    <h2 class="mb0">CHF200</h2>
                    <p>On your <span>first dinner date!</span></p>
                    <div class="box1">
                        <img src="@/assets/img/big-gift.png" class="big-img" alt="big-img">
                        <img src="@/assets/img/small-gift.png" class="small-img" alt="small-img">
                        <transition name="fade" mode="out-in">
                            <div class="popup" v-if="popupTrigger">
                                <a href="javascript:;" class="close" @click="popupTrigger = false">
                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M0.981683 17.0396C1.93901 14.9401 3.47608 12.5489 5.32043 10.2203C3.61003 8.3547 1.84749 6.62344 0.212394 5.17873C-0.0296413 4.96551 -0.0709572 4.57221 0.120166 4.30211C0.202804 4.18475 0.320711 4.10473 0.452105 4.07683C1.76259 3.7878 2.79826 3.92521 3.72276 4.37708C4.62484 4.81857 5.38913 5.54831 6.18973 6.46968C6.5348 6.86727 6.92159 7.33119 7.33268 7.84123C7.63977 7.50103 7.95118 7.16573 8.26683 6.83542C11.1542 3.81497 14.3854 1.23775 17.2423 0.0402533C17.5318 -0.0812662 17.8552 0.0815676 17.9641 0.404643C18.0035 0.521578 18.0107 0.648994 17.9847 0.770507C17.9587 0.892021 17.9007 1.00208 17.8182 1.08653C16.6305 2.50074 15.2644 3.98986 13.8388 5.54357C12.3666 7.14858 10.8303 8.82375 9.39897 10.5102C9.73537 10.9604 10.0684 11.4137 10.398 11.8701C11.7162 13.6965 12.9198 15.4953 13.5632 16.6889C13.7219 16.9849 13.6354 17.3691 13.3702 17.5462C13.2568 17.6221 13.1228 17.6505 12.9923 17.6262L11.2302 17.3768C11.1561 17.3664 11.0845 17.3395 11.0199 17.2977C10.9553 17.2559 10.8988 17.2001 10.8539 17.1335C9.87607 15.687 8.75201 14.2142 7.55542 12.7764C6.26655 14.443 5.15563 16.0945 4.38704 17.6741C4.28285 17.8882 4.08213 18.0066 3.87752 17.9997L1.47232 17.9472C1.16351 17.942 0.917235 17.6577 0.921882 17.3131C0.923205 17.2181 0.943642 17.1246 0.981683 17.0396Z" fill="white"/>
                                    </svg>
                                </a>

                                <h3>Please provide us:</h3>
                                <ul>
                                    <li><p>Both usernames who went on the date.</p></li>
                                    <li><p>Send us picture or video from the dinner saying:”easytreff.com dinner date was great”.</p></li>
                                    <li><p>The rights to publish it on our social media and home page as social proof.</p></li>
                                </ul>
                                <p>If you are <span>compliant</span> with getting the <span>chf200</span> you can get money wired on your account or get <span>300 credits</span> which is worth <span>chf 300.</span></p>
                            </div>
                        </transition>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
export default {
    name: "SpecialGfOffer",
    props: {
        headerVisibility: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            popupTrigger: false,
            paymentDropdown: false,
            radioValue: 'Credit card'
        }
    },
    methods: {
        getValue(event) {
            this.radioValue = event.target.value
        }
    }
}
</script>
<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:ital,wght@0,200..800;1,200..800&family=Red+Hat+Display:ital,wght@0,300..900;1,300..900&display=swap');
.check-box input, .radio-box input {
    visibility: hidden;
    opacity: 0;
    position: absolute;
    z-index: -1;
}
.radio-box label {
    display: flex;
    align-items: center;
}

.check-box label {
    display: flex;
}

.radio-box {
    vertical-align: middle;
    margin-bottom: 15px;
}
.radio-box .radio-icon {
    width: 14px;
    height: 14px;
    border-radius: 2px;
    border: 1px solid #FFF;
    background-color: transparent;
    margin-right: 10px;
    position: relative;
    transition: all 0.3s ease;
}
.radio-box .radio-icon:before {
    position: absolute;
    left: 50%;
    top: 50%;
    content: "";
    width: 8px;
    height: 8px;
    background-color: #000;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    border-radius: 50%;
    transition: all 0.3s ease;
    visibility: hidden;
    opacity: 0;
}
.radio-box label {
    font-weight: 400;
    cursor: pointer;
}

.radio-box input:checked + label .radio-icon {
    background-color: #fff;
}
.radio-box input:checked + label .radio-icon:before {
    visibility: visible;
    opacity: 1;
}
.radio-box input:disabled + label {
    pointer-events: none;
    opacity: 0.8;
    cursor: not-allowed;
}
.radio-box .radio-text {
    margin-bottom: 0;
    color: #fff;
    font-family: "Red Hat Display", sans-serif;
    font-size: 14px;
    font-weight: 500;
    margin-left: 10px;
}
.check-box {
    margin-bottom: 15px;
}
.check-box .check-icon {
    width: 10px;
    min-width: 10px;
    height: 10px;
    border-radius: 2%;
    background-color: #fff;
    margin-right: 10px;
    position: relative;
    transition: all 0.3s ease;
}
.check-box .check-icon svg {
    position: absolute;

    left: 50%;
    top: 50%;
    content: "";
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    transition: all 0.3s ease;
    visibility: hidden;
    opacity: 0;
}
.check-box label {
    font-weight: 400;
    cursor: pointer;
}
.check-box input:checked + label .check-icon svg {
    visibility: visible;
    opacity: 1;
}
.check-box input:disabled + label {
    pointer-events: none;
    opacity: 0.8;
    cursor: not-allowed;
}
.check-box .check-text {
    margin-bottom: 0;
    color: #fff;
    font-size: 14px;
    margin-top: -5px;
    text-align: left;
    line-height: 1.4;
    font-family: "Red Hat Display", sans-serif;
}

.check-box .check-text a {
    color: #B98A56;
    font-family: "Red Hat Display", sans-serif;
    font-size: 14px;
    text-decoration: none;
}

.container {
    width: 100%;
    max-width: 1220px;
    margin: 0 auto;
}

.header--main {
    background: #111317;
    box-shadow: 0px 8px 24.8px 0px rgba(0, 0, 0, 0.35);
    height: 60px;
    display: flex;
    position: relative;
    z-index: 999;
}

.header--main .container {
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
}

.header--main a {
    font-weight: 600;
    font-size: 18px;
    color: #fff;
    text-decoration: none;
    font-family: "Red Hat Display", sans-serif;
}

.promo-section {
    min-height: calc(100dvh - 60px);
    padding: 80px 0;
    background: #111317;
    background-image: url('../assets/img/gold-orb.svg');
    background-repeat: no-repeat;
    background-position: 50% 110%;
}

.heading-box {
    text-align: center;
    margin-bottom: 30px;
}

.heading-box h1 {
    color: #FFF;
    font-size: 48px;
    margin-bottom: 10px;
    font-family: "Red Hat Display", sans-serif;
}

.heading-box p {
    color: #B98A56;
    font-size: 18px;
    font-family: "Plus Jakarta Sans", sans-serif;
    margin-bottom: 0;
}

.promo-grid {
    display: flex;
    gap: 50px;
    align-items: center;

}

.grid-item {
    width: calc(33.33% - 25px);
}

.grid-item .box {
    padding: 25px;
    border-radius: 16px;
    /* border: 1px solid #FFF; */
    background: linear-gradient(100deg, rgba(255, 255, 255, 0.03) -0.77%, rgba(255, 255, 255, 0.04) 101.05%);
    box-shadow: 4px 20px 40px 0px rgba(0, 0, 0, 0.77);
    backdrop-filter: blur(5.129803657531738px);
}

.grid-item-payment-method .box {
    margin-bottom: 25px;
}

.grid-item-payment-method .drop-trigger {
    border-radius: 50px;
    background: linear-gradient(100deg, rgba(255, 255, 255, 0.03) -0.77%, rgba(255, 255, 255, 0.04) 101.05%);
    box-shadow: 4px 20px 40px 0px rgba(0, 0, 0, 0.77);
    backdrop-filter: blur(5.129803657531738px);
    height: 50px;
    margin-bottom: 15px;
    padding: 0 25px;

    align-items: center;
    justify-content: space-between;
    color: #B98A56;
    font-family: "Red Hat Display", sans-serif;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    display: none;
}

.grid-item-payment-method .drop-trigger span {
    display: flex;
    align-items: center;
    gap:10px;
    color: #fff;
}

.grid-item-payment-method .drop-trigger p {
    margin-bottom: 0;
}

.grid-item-payment-method .check-box {
    position: relative;
    z-index: 1;
}

.grid-item-payment-method .check-box .check-text {
    color: #FFF;
    font-family: "Red Hat Display", sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.4;
}

.grid-item-payment-method .check-box .check-text a {
    color: #B98A56;
    text-decoration: none;
}


.grid-item-payment-method h2 {
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 25px;
    color: #fff;
    font-family: "Red Hat Display", sans-serif;
}

.grid-item-payment-method p {
    color: #B98A56;
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 25px;
    font-family: "Red Hat Display", sans-serif;
}

.grid-item-premium {
    text-align: center;
}

.grid-item-premium .box {
    margin-bottom: 15px;
}

.grid-item-premium .popup-trigger {
    color: rgba(255, 255, 255, 0.40);
    font-family: "Red Hat Display", sans-serif;
    font-size: 18px;
    position: relative;
    z-index: 1;
    transition: all .3s ease;
    text-decoration: none;
}

.grid-item-premium .popup-trigger:hover {
    color: #fff;
}

.grid-item-premium h2 {
    font-family: "Red Hat Display", sans-serif;
    font-size: 40px;
    font-weight: 700;
    margin-bottom: 10px;
    margin-top: 17px;
    color: #fff;
}

.grid-item-premium h3 {
    color: #B98A56;
    font-family: "Plus Jakarta Sans";
    font-size: 24px;
    font-weight: 500;
}

.grid-item-premium .divider {
    background-color: #fff;
    height: 1px;
    width: 80%;
    margin: 20px auto 15px;
}

.grid-item-premium h4 {
    font-family: "Plus Jakarta Sans";
    font-size: 18px;
    font-weight: 700;
    text-transform: uppercase;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    margin-bottom: 35px;
    color: #fff;
}

.grid-item-premium h4 span {
    color: rgba(255, 255, 255, 0.50);
    font-weight: 500;
}

.grid-item-premium .text {
    color: rgba(255, 255, 255, 0.80);
    font-family: "Red Hat Display", sans-serif;
    font-size: 16px;
    margin-top: 10px;
    margin-bottom: 20px;
}

.button--primary {
    width: 274px;
    height: 64px;
    border-radius: 54px;
    background: #B98A56;
    box-shadow: 0px 10px 30px 0px rgba(0, 0, 0, 0.73), -5px -3px 20.544px 0px #2F393D;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    font-family: "Red Hat Display";
    font-size: 20px;
    font-weight: 600;
}

.grid-item-premium .button--primary {
    margin-bottom: 20px;
}

.grid-item-premium .check-box {
    margin-bottom: 0;
}

.grid-item-premium .link {
    color: rgba(255, 255, 255, 0.80);
    font-family: "Red Hat Display", sans-serif;
    font-size: 16px;
    text-decoration: none;
    margin-top: 10px;
    display: inline-block;
    margin-bottom: 15px;
}

.grid-item-gift h3 {
    color: #B98A56;
    font-family: "Red Hat Display", sans-serif;
    font-size: 20px;
    font-weight: 600;
}

.grid-item-gift h2 {
    color: #FFF;
    font-family: "Red Hat Display", sans-serif;
    font-size: 50px;
    font-weight: 900;
}

.grid-item-gift p {
    color: #ffffff;
    font-family: "Red Hat Display", sans-serif;
    font-size: 18px;
    font-weight: 400;
    margin-bottom: 10px;
}

.grid-item-gift p span {
    color: #B98A56;
}


.box1 {
    background-repeat: no-repeat;
    background-position: 50% 50%;
    background-image: url('../assets/img/couple.png');
    background-size: cover;
    aspect-ratio: 1 / 1;
    border-radius: 16px;
    box-shadow: 1px 10px 14.8px 0px rgba(0, 0, 0, 0.63);
    position: relative;
}

.box1 .big-img {
    position: absolute;
    right: 0;
    bottom: 100%;
    transform: translate(40px, 35px);
    max-width: 190px;
}

.box1 .small-img {
    position: absolute;
    left: -30px;
    bottom: -40px;
}

.popup {
    position: absolute;
    padding: 23px 15px;
    border-radius: 16px;
    left: 0;
    bottom: 0;
    width: 100%;
    background-image: url(../assets/img/info-box.png);
    background-repeat: no-repeat;
    background-position: 50% 50%;
    background-size: 100% 100%;
    box-shadow: -30px 20px 40px 0px rgba(0, 0, 0, 0.87);
}

.popup h3 {
    color: #FFF;
    font-family: "Plus Jakarta Sans";
    font-size: 20px;
    font-weight: 300;
    margin-bottom: 20px;
}

.popup .close {
    float: right;
}

.popup ul {
    padding-left: 20px;
    list-style-type:disc;
    padding-right: 35px;
    margin-bottom: 20px;
}

.popup ul {
    color: #FFF;
}

.popup ul p {
    color: #FFF;
    font-family: "Plus Jakarta Sans";
    font-size: 16px;
    line-height: 1.3;
    font-weight: 300;
}

.popup >p {
    margin-bottom: 0;
    font-family: "Plus Jakarta Sans";
    font-size: 14px;
    opacity: .8;
}

@media(max-width: 1300px) {

    .header--main {
        height: 48px;
        padding: 0 24px;
    }

    .grid-item-premium {
        margin-bottom: 80px;
    }

    .grid-item-payment-method .drop-trigger {
        display: flex;
    }

    .grid-item-payment-method .box-drop {
        padding: 0;
        transition: max-height 0.3s cubic-bezier(0,1,0,1);
        max-height: 0;
        height: auto;
        overflow: hidden;
        margin-bottom: 0;
    }

    .box-drop .dropdown {
        padding: 25px;
    }

    .grid-item-payment-method .dropdown > p {
        display: none;
    }

    .box-drop.active  {
        transition: max-height 0.5s cubic-bezier(1,0,1,0);
        max-height: 99999px;
    }

    .promo-grid {
        flex-direction: column;
        gap: 0;
    }



    .promo-grid .grid-item {
        width: 380px;
    }

    .promo-section {
        padding: 20px 0 80px;
        overflow: hidden;
    }

    .heading-box h1 {
        font-size: 28px;
    }

    .heading-box p {
        font-size: 16px;
    }
}


@media(max-width: 480px) {

    .container {
        padding: 0 10px;
    }
    .promo-grid .grid-item {
        width: 100%;
    }
}
</style>